import axios from "axios";

import { store } from "redux/store";

import {
  ISelectedMerchantRequest,
  ISelectedMerchantResponse,
  IAuthNativeSuccessRequest,
  IAuthNativeSuccessResponse,
} from "models/Login/choiceMerchant.model";

/// 4th api
export const MerchantSwitch = async (): Promise<IAuthNativeSuccessResponse> => {
  let returnData: IAuthNativeSuccessResponse = {};
  const reduxStore = store.getState();
  let merchantSwitchParams: ISelectedMerchantRequest = {};

  merchantSwitchParams.TokenSessionId =
    reduxStore.login.user?.tokenSessionID ||
    reduxStore.login.user?.TokenSessionId;

  const { selectedMerchant } = reduxStore.merchant;
  merchantSwitchParams.MerchantNo = selectedMerchant;

  const reqData = serviceMerchantSwitchModelCreator(merchantSwitchParams);
  try {
    //4. api
    const { data } = await axios.post<ISelectedMerchantResponse>(
      "/Token",
      reqData
    );

    const _merchantName = data.MerchantName;

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;
    if (data.NextScreens.length === 0) {
      //5. api
      returnData = await MerchantAuthSuccess(
        merchantSwitchParams.TokenSessionId!
      );
      returnData.MerchantName = _merchantName;
    }
    return returnData;
  } catch (error) {
    console.log(`MERCHANT_SWITCH_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceMerchantSwitchModelCreator = (
  merchantSwitchParams: ISelectedMerchantRequest
) => {
  let req = {
    MerchantNo: merchantSwitchParams.MerchantNo,
    TokenSessionId: merchantSwitchParams.TokenSessionId,
    androidUID: null,
    carrier: null,
    changeKey: null,
    ChannelKey: null,
    clientDeviceID: null,
    ClientUid: null,
    connectionType: null,
    DeviceBrand: null,
    DeviceModel: null,
    deviceOs: null,
    deviceOsType: null,
    DeviceOsVersion: null,
    deviceType: null,
    deviceVersion: null,
    hardOtpFlag: false,
    imei: null,
    isCracked: null,
    softOtpFlag: null,
    kullAdiEnc: null,
    userAgent: null,
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    igsEnc: null,
    NextTransactionUrl: "ModAuthSwitchMccConfirm",
  };

  return req;
};
/// 4th api call ------------/

/// 5th api call ------------/
export const MerchantAuthSuccess = async (
  tokenSessionId: string
): Promise<IAuthNativeSuccessResponse> => {
  try {
    // const reduxStore = store.getState();
    let merchantAuthSuccessParams: IAuthNativeSuccessRequest = {};
    merchantAuthSuccessParams.TokenSessionId = tokenSessionId;
    // merchantAuthSuccessParams.clientUID = reduxStore.login.clientUID;
    const reqData = serviceMerchantSuccessModelCreator(
      merchantAuthSuccessParams.TokenSessionId
      // merchantAuthSuccessParams.clientUID
    );
    const { data } = await axios.post<IAuthNativeSuccessResponse>(
      "/Token",
      reqData
    );

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;
    return data;
  } catch (error) {
    console.log(`MERCHANT_SUCCESS_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceMerchantSuccessModelCreator = (
  _tokenSessionId: string
  // clientUid: string
) => {
  let req = {
    //clientUid,
    clientUID:
      "A5F37496E41C9DA75D41D905F263F9E1C5D2D9F4C2503C9D78814A5C476B040FA4F5EF837F451AB2990F884DB274E4B8B132178EAC06DA0834A148BA8471B2127069FCFD399DBBB4",
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: _tokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthNativeSuccess",
  };

  return req;
};
/// 5th api call ------------/
